export default "__VITE_ASSET__CMwNRGBn__"